import func from '../common/function';
import cd from '../data/cluster-data';
import data from '../data/cluster-overview';
import cf from '../common/config';
import ci from '../data/cluster-info';
import cluster from './cluster';
import snapshot from './snapshot';
import queryParams from '../data/queryparams';

let uiDefault = {
  init :()=>{
    if(cd.health.cluster_name){
      uiDefault.bindStatus().bindTabMenu().bindHeaderMenu().bindOverview().bindEvents();
    }else{
      uiDefault.bindStatus().bindEvents();
    }
  },
  bindOverview : ()=>{
    cluster.bindOverview();
    return uiDefault;
  },
  bindSnapshots : ()=>{
    snapshot.bindSnapshot();
    return uiDefault;
  },
  clearContents : ()=>{
    $('.ui-tab-menu').siblings().remove();
    return uiDefault;
  },
  clearAll: ()=>{
    $('header').html('');
    $('main').html('');
    return uiDefault;
  },
  bindTabMenu :()=>{
    let $tabMenu = $(`<ul class="ui-tab-menu"></ul>`);
    $tabMenu.append(`<li class="active">Overview</li>`).append(`<li>Snapshots</li>`);
    $tabMenu.click(e=>{
      let $this = $(e.target);
      ($this.prop("tagName") === 'LI') && (!$this.hasClass('active')) && $this.addClass('active').siblings().removeClass('active') && uiDefault.clearContents() && $('.ui-modal').hide() && eval('uiDefault.bind'+$this.text())();
    });
    $('main').append($tabMenu);
    return uiDefault;
  },
  bindStatus: ()=>{
    console.log(queryParams.get('hide_connect_ui'));
    let hideConnectUIMode = queryParams.get('hide_connect_ui') || queryParams.get('hide_connect_ui') === 'true';
    let $status = $(`<div class="ui-cluster-status"><h2>${cd.health.cluster_name || ''}</h2></div>`);
    if(!hideConnectUIMode){
	    $status.append(`<input type="text" name="logserver" value="${cf.dbserver.get()}">`).append(`<button type="button" name="btnConnect">connect</button>`);
    }
    if(cd.health.active_shards_percent_as_number){
      $status.append(`<span class="icon-status ${cd.health.status}"></span> ${!cd.health.active_shards_percent_as_number ? '-' : (cd.health.active_shards_percent_as_number%2===0) ? cd.health.active_shards_percent_as_number : cd.health.active_shards_percent_as_number.toFixed(2)}% (${cd.health.shards && cd.health.shards.successful || '-'} of ${cd.health.shards && cd.health.shards.total || '-'} )`);
    } else {
      $status.append(`<span class="icon-status"></span> not connected`);
    }
    $('header').append($status);
    return uiDefault;
  },
  bindHeaderMenu: ()=>{
    let menu = [], title;
    title = 'Info';
    menu.push({title:title, action: ()=>{
      func.openJson(title, ci.info());
    }});
    title = 'Indices Stats';
    menu.push({title:title, action: ()=>{
      func.openJson(title, ci.index.stats());
    }});
    title = 'Nodes Stats';
    menu.push({title:title, action: ()=>{
      func.openJson(title, ci.nodes.stats());
    }});
    title = 'Nodes Info';
    menu.push({title:title, action: ()=>{
      func.openJson(title, ci.nodes.info());
    }});
    title = 'Plugins';
    menu.push({title:title, action: ()=>{
      func.openJson(title, ci.plugins());
    }});
    title = 'Cluster State';
    menu.push({title:title, action: ()=>{
      func.openJson(title, ci.cluster.state());
    }});
    title = 'Cluster Health';
    menu.push({title:title, action: ()=>{
      func.openJson(title, ci.cluster.health());
    }});
    title = 'Templates';
    menu.push({title:title, action: ()=>{
      func.openJson(title, ci.template());
    }});
    $('.ui-cluster-status').append(func.dropdown(menu));
    return uiDefault;
  },
  bindEvents: ()=>{
    let $logserver = $('[name=logserver]'),
        $btnConn = $('[name=btnConnect]');

    $btnConn.click(()=>{
      if($logserver.val()==='') {
        $logserver.focus();
      }
      cf.dbserver.set($logserver.val());
      data.cluster();
      uiDefault.clearAll().init();
    });
    $logserver.keyup(e=>{
      (e.which === 13) && $btnConn.trigger('click');
    });
  }
}

export default uiDefault;



// WEBPACK FOOTER //
// ./src/scripts/ui/default.js